import { Machines } from '../../../../datamodels';
import MachineCatalog from '../../../machines/MachineCatalog';

interface AddMachinesFromTheListProps {
  onSelectMachine: (machine: Machines) => void;
}

const AddMachinesFromTheList: React.FC<AddMachinesFromTheListProps> = ({
  onSelectMachine,
}) => (
  <MachineCatalog
    mode="select"
    showCategories={false}
    onSelectMachine={onSelectMachine}
  />
);

export default AddMachinesFromTheList;
